"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * equals to objects properties (only first level)
 *
 * if o1 or o2 not defined it will be falls
 * @param o1 first object to compare
 * @param o2 second object to compare
 */
exports.equalObjects = function (o1, o2) {
    if (!o1 && !o2) {
        return true;
    }
    if (o1 && !o2) {
        return false;
    }
    if (o1 && !o2) {
        return false;
    }
    var equalObject = function (obj1, obj2) {
        for (var _i = 0, _a = Object.keys(obj1); _i < _a.length; _i++) {
            var val = _a[_i];
            if (!obj2[val]) {
                return false;
            }
            if (obj1[val] !== obj2[val]) {
                return false;
            }
        }
        return true;
    };
    if (!equalObject(o1, o2)) {
        return false;
    }
    return equalObject(o2, o1);
};
//# sourceMappingURL=equal-objects.js.map